module.exports = __webpack_public_path__ + "img/msfa.8f127c4.png";